import { apiClient } from '../shared/api-client';

const DEFAULT_EMAIL_MESSAGES = {
    empty: 'Email cannot be empty.',
    invalid: email => `The email ${email} may have a mistake or might not work.`,
    didYouMean: suggestion => `Did you mean ${suggestion}?`
};

function validateEmail(email, messages = {}) {
    const msg = { ...DEFAULT_EMAIL_MESSAGES, ...messages };

    if (!email.trim()) {
        return {
            isValid: false,
            message: msg.empty
        };
    }

    const isValidEmail = String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

    if (isValidEmail === null) {
        return {
            isValid: false,
            message: msg.invalid(email)
        };
    }

    return {
        isValid: true,
        message: ''
    };
}

async function asyncValidateEmail(email, messages = {}) {
    const msg = { ...DEFAULT_EMAIL_MESSAGES, ...messages };

    try {
        await apiClient.post({
            url: 'auth/email/validate',
            body: { email },
            isCheckAccessToken: false
        });

        return {
            isValid: true,
            message: ''
        };
    } catch (error) {
        if (error?.response.didYouMean) {
            return {
                isValid: false,
                message: msg.didYouMean(error.response.didYouMean),
                data: {
                    didYouMean: error.response.didYouMean
                }
            };
        }

        return {
            isValid: false,
            message: msg.invalid(email)
        };
    }
}

export {
    validateEmail,
    asyncValidateEmail,
    DEFAULT_EMAIL_MESSAGES
};
